import { css } from '@styled-system/css'
import { SeeAllButton } from 'components_v2/Header/Navbar/Menus/Desktop/RightContent/Search/SearchDrawer/common'
import LotusEllipse from 'components_v2/NotFound/LotusEllipse'
import React from 'react'
import styledComponents from 'styled-components'
import { Box, Container, Fade, Flex, P } from 'ui/acro'

const GapContainer = styledComponents(Flex)`
  ${css({
    gap: '20px'
  })}
`
const Title = styledComponents(Box)`
  ${css({
    fontWeight: 600,
    textAlign: 'center',
    fontSize: ['21px', '21px', '29px'],
    fontFamily: 'Proxima-nova',
    lineHeight: ['28.35px', '37.7px']
  })}
`

const NoResultsFound = ({ query }) => {
  return (
    <Fade>
      <Container id='NoResultsFound' pt='15%' pb='15%' height='80vh'>
        <GapContainer flexDirection='column' alignItems='center' gap='15px'>
          <LotusEllipse />
          <Title>Sorry, we couldn’t find any results for "{query}"</Title>
          <P
            color='#3B3B3B'
            textAlign='center'
            fontSize='16px'
            lineHeight='22.4px'
          >
            Please try different keywords in another search
            <br></br>or check out our most popular classes:
          </P>
          <GapContainer flexDirection={['column', 'row']}>
            <a
              id={'NoResultsFitness'}
              href='/class-finder?styles=fitness&order=date'
            >
              <SeeAllButton variant='tertiary'>Fitness</SeeAllButton>
            </a>
            <a id={'NoResultsYoga'} href='/class-finder?styles=yoga&order=date'>
              <SeeAllButton variant='tertiary'>Yoga</SeeAllButton>
            </a>
            <a
              id={'NoResultsMindfulness'}
              href='/class-finder?styles=mindfulness&order=date'
            >
              <SeeAllButton variant='tertiary'>Mindfulness</SeeAllButton>
            </a>
          </GapContainer>
        </GapContainer>
      </Container>
    </Fade>
  )
}

export default NoResultsFound
